import React from "react";
import { PillDropdown } from "../comps/PillDropdown";
import { useLensesV2Context } from "./LensesV2Context";

// Global filter bar for the Lenses 2 dashboard. Date for now; location/segments
// slot in here later (all driven from LensesV2Context).
export const LensesV2FilterBar = () => {
  const { periodOptions, period, setPeriod } = useLensesV2Context();

  if (!periodOptions.length || !period) return null;

  return (
    <div style={{ display: "flex", gap: "0.8rem", alignItems: "center" }}>
      <PillDropdown
        value={period}
        options={periodOptions}
        onChange={(id, val) => {
          const opt = periodOptions.find((p) => p.value === (val?.value ?? val));
          if (opt) setPeriod(opt);
        }}
      />
    </div>
  );
};
